module.exports = __webpack_public_path__ + "img/publishing-schedule-icon-white.2675b611.svg";